import {
  container,
  defaultFont,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  roseColor,
  transition,
  boxShadow,
  drawerWidth,
  headerColor
} from "./material-kit-react.js"
import {colors} from '../components/Theme/WebTheme';

const headerStyle = {
  appBar: {
    display: "flex",
    border: "0",
    borderRadius: "0",
    padding: "14px 16px",
    margin: "0",
    color: "#FFFFFF",
    width: "100%",
    backgroundColor: "transparent !important",
    boxShadow: "none !important",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    alignItems: "center",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    position: "relative",
    zIndex: "1200",
    "@media (max-width: 600px)": {
      padding: "10px 10px"
    }
  },
  absolute: {
    position: "absolute",
    zIndex: "1100"
  },
  fixed: {
    position: "fixed",
    zIndex: "1100"
  },
  scrolled: {
    paddingTop: "9px",
    "& $container": {
      backgroundColor: "rgba(12, 17, 14, 0.97)",
      borderColor: "rgba(183, 238, 0, 0.24)",
      boxShadow: "0 16px 44px rgba(5, 9, 7, 0.24)"
    }
  },
  container: {
    ...container,
    minHeight: "70px",
    flex: "1",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    flexWrap: "nowrap",
    boxSizing: "border-box",
    maxWidth: "1180px",
    width: "100%",
    padding: "7px 10px 7px 12px",
    backgroundColor: "rgba(10, 15, 12, 0.82)",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    borderRadius: "22px",
    boxShadow: "0 18px 50px rgba(4, 8, 6, 0.19)",
    color: "#FFFFFF",
    backdropFilter: "blur(18px)",
    WebkitBackdropFilter: "blur(18px)",
    transition: "background-color 220ms ease, border-color 220ms ease, box-shadow 220ms ease",
    "@media (max-width: 600px)": {
      minHeight: "60px",
      borderRadius: "18px",
      padding: "5px 7px 5px 8px"
    }
  },
  flex: {
    flex: 1
  },
  title: {
    ...defaultFont,
    lineHeight: "32px",
    fontSize: "20px",
    borderRadius: "14px",
    textTransform: "none",
    color: "inherit",
    minWidth: "0",
    padding: "0",
    letterSpacing: "-0.02em",
    fontWeight: "600",
    transition: "all 0.3s ease",
    "@media (max-width: 600px)": {
      padding: "0"
    },
    "&:hover,&:focus": {
      color: "inherit",
      background: "transparent",
      transform: "translateY(-1px)"
    }
  },
  brandMark: {
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.96)",
    border: "1px solid rgba(17, 20, 17, 0.08)",
    borderRadius: "13px",
    boxShadow: "0 8px 22px rgba(0, 0, 0, 0.2)",
    display: "inline-flex",
    justifyContent: "center",
    padding: "7px 10px",
    "& img": {
      display: "block",
      height: "auto",
      width: "96px"
    },
    "@media (max-width: 600px)": {
      borderRadius: "11px",
      padding: "5px 8px",
      "& img": {
        width: "82px"
      }
    }
  },
  appResponsive: {
    margin: "10px 0 24px",
    padding: "0 10px"
  },
  menuButton: {
    alignItems: "center",
    backgroundColor: "#B7EE00 !important",
    borderRadius: "13px !important",
    color: "#111411 !important",
    display: "flex",
    height: "44px",
    justifyContent: "center",
    width: "44px",
    "&:hover": {
      backgroundColor: "#CCFF1C !important"
    }
  },
  drawerHeader: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    padding: "18px 18px 14px"
  },
  drawerBrand: {
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    display: "inline-flex",
    padding: "7px 10px",
    "& img": {
      display: "block",
      height: "auto",
      width: "94px"
    }
  },
  closeButton: {
    backgroundColor: "rgba(255,255,255,0.08) !important",
    color: "#FFFFFF !important",
    height: "42px",
    width: "42px"
  },
  primary: {
    backgroundColor: primaryColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(156, 39, 176, 0.46)"
  },
  info: {
    backgroundColor: infoColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(0, 188, 212, 0.46)"
  },
  success: {
    backgroundColor: successColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(76, 175, 80, 0.46)"
  },
  warning: {
    backgroundColor: warningColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(255, 152, 0, 0.46)"
  },
  danger: {
    backgroundColor: dangerColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(244, 67, 54, 0.46)"
  },
  rose: {
    backgroundColor: roseColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(233, 30, 99, 0.46)"
  },
  transparent: {
    backgroundColor: "transparent !important",
    boxShadow: "none",
    color: "#FFFFFF",
  },
  dark: {
    color: "#FFFFFF",
    backgroundColor: "#212121 !important",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(33, 33, 33, 0.46)"
  },
  white: {
    border: "0",
    padding: "0.625rem 0",
    marginBottom: "20px",
    color: "#555",
    backgroundColor: "#fff !important",
    boxShadow:
      "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)"
  },
  header: {
    backgroundColor: headerColor,
    color: colors.Header_Content,
    boxShadow:
      "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)"
  },
  drawerPaper: {
    background: "linear-gradient(160deg, #0B100D 0%, #121B2D 100%)",
    border: "1px solid rgba(183, 238, 0, 0.16)",
    bottom: "0",
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    width: `min(${drawerWidth}px, calc(100vw - 18px))`,
    ...boxShadow,
    position: "fixed",
    display: "block",
    top: "0",
    height: "100vh",
    right: "0",
    left: "auto",
    visibility: "visible",
    overflowY: "auto",
    borderTop: "none",
    textAlign: "left",
    paddingRight: "0px",
    paddingLeft: "0",
    color: "#FFFFFF",
    boxShadow: "-22px 0 65px rgba(3, 7, 5, 0.34)",
    ...transition
  }
};

export default headerStyle;
